<div class="wrapper-select-topics-and-artist-page">
  <div class="content-select-topics-and-artist">
<!--    <div class="back-btn">-->
<!--      <img src="../assets/icons/icon-arrow-left.svg" alt="">-->
<!--    </div>-->
    <h1>{{'SETUP_SCREEN.what_topics_are_you_interested_in' | translate}}</h1>
    <h6>
      {{'SETUP_SCREEN.select_topics_you_prefer_to_have_better_lists_recommendations' | translate}}
    </h6>
    <div class="wrapper-content-select-artist" (scroll)="onScroll($event)">
      <div class="wrapper-custom-checkbox-select-topics">
        <label *ngFor="let topic of topics">
          <input type="checkbox" name="radioname" [(ngModel)]="topic.selected" (change)="onSelectTopicChange(topic)">
          <div class="custom-checkbox-select-topics">
            <div class="check-topic">
              <img src="../assets/icons/outline/icon-check.svg" alt="">
            </div>
            <div class="wrapper-select-topics-info">
              <span>{{topic.name}}</span>
            </div>
          </div>
        </label>
      </div>
    </div>
    <button (click)="onClickToContinue()" [disabled]="numberOfSelectedTopics < 3" class="custom-btn custom-btn--primary xs-mt-12">
      <span>
        {{'GENERAL.continue' | translate}}
      </span>
    </button>
    <div class="wrapper-label-gray">
      <span> {{'SETUP_SCREEN.please_select_topics_that_may_interest_you_or_skip_this_step' | translate}}</span>
    </div>
  </div>
</div>
